/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  margin-top: 30px;
  h3 {
    font-family: Roboto;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
    color: #5e5e5e;
  }
  .MuiDivider-root {
    background-color: #e6e6e6;
    margin-top: 10px;
  }
  .hue{
    margin-top: 10px;
  }
  .hue-disabled {
    height: 16px;
    width: 315px;
    margin-top: 10px;
  }    
`;

export const HueDisabled = styled.div`
  margin-top: 30px;
  background: rgb(174, 174, 174);
  width: 100px;
`;